var path = '/templates/projects.segments/campaign_segment_edit_inactive.html';
var html = "<h4>{{ 'projectsSegments.campaignSegmentEditInactive.kihonjouken' | translate }}</h4><table class=\"table table-bordered segment-detail-table\"><tr><th><zc-campaign-segment-flag segment=segment short=true></zc-campaign-segment-flag></th><td>{{ 'projectsSegments.campaignSegmentEditInactive.kai_ijou_kounyuu' | translate }}) <input type=number ng-model=segment.conditions_json.days_since_last_conversion ng-min=30 style=width:50px required> {{ 'projectsSegments.campaignSegmentEditInactive.hi_ijou_saki' | translate }})</td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.segments/campaign_segment_edit_inactive.html
// module id = 1482
// module chunks = 0